import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import * as proposalService from "../../../services/service/proposalService"
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const ProjectLogComponent = (props) => {
    const { auth } = props;
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchProjectLogs();
    }, [])

    const fetchProjectLogs = () => {
        proposalService.GetProposalProjectLogs().then(res => {
            setData(res);
        }).catch(ex => {
            console.log("Something went wrong!!");
        })
    }

    const columns = [
        {
            name: "projectNumber",
            label: "Project #",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({ style: { width: "9%" } }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div>
                            {
                                (auth.isAdmin || auth.isProjectManager || auth.isTechnician) ?
                                    <Link
                                        to={data[dataIndex].jobId !== 0 ? "/services/manage-job/general-information/" + data[dataIndex].jobId : "/services/manage-proposal/general-information/" + data[dataIndex].id}>
                                        {data[dataIndex].projectNumber}
                                    </Link> :
                                    <p>{data[dataIndex].projectNumber}</p>
                            }

                        </div>
                    )
                },
            }
        },
        {
            name: "createdDateTime",
            label: "Date Created",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "client",
            label: "Client",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "projectType",
            label: "Project Type",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "projectSubType",
            label: "ProjectSubType",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "projects",
            label: "Projects",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "clientLocation",
            label: "Client Location",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "referralSource",
            label: "Referral Source",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "projectManager",
            label: "Project Manager",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];

    return (
        <div className="col-lg-12 col-xxl-12">
            <div className={`card card-custom card-stretch gutter-b}`}>
                <div className="card-header border-0 py-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            Project Logs
                        </span>
                    </h3>
                </div>
                <div className="container-fluid">
                    <MUIDataTable
                        data={data}
                        columns={columns}
                        options={{
                            rowsPerPage: 25,
                            selectableRows: 'none',
                            rowsPerPage: 25,
                            fixedHeader: true,
                            fixedSelectColumn: true,
                            tableBodyHeight: '90vh'
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(ProjectLogComponent);